import { ActivatedRoute, Router } from '@angular/router';
import { DashboarduiService } from 'src/app/components/Shared/Service/dashboardui.service';
import { Location } from '@angular/common';
import { MatTableDataSource } from '@angular/material';
import { ToastrService } from 'ngx-toastr'
import beautify from 'xml-beautifier';
import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: Date;
  pusheddate: any;
  type: any
}

@Component({
  selector: 'app-fom-from-crmdb-new-list',
  templateUrl: './fom-from-crmdb-new-list.component.html',
  styleUrls: ['./fom-from-crmdb-new-list.component.css']
})
export class FomFromCrmdbNewListComponent implements OnInit {

  dataSource: MatTableDataSource<idsProductList>;
  filteredList: any[] = [];
  pmscode: number;
  status: string;
  fromDate: string;
  toDate: string;
  isLoading = true;
  selectedHotelName: string = '';
   
     Val: string='';
       totalcount: any = 0;
        XMLName: any;
  defaultData: any;
  XMLstatus: any;
  isProgressing: Boolean = false;
filterProperty: any[] = [];
  display: Boolean = false;
  vkbeautify: any;
   stateData: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiCallIdsService: DashboarduiService,
     private toastr: ToastrService
  ) {}
detailedDisplayedColumns: string[] = [
 // 'hotelname',
  'accdat',
  'regnub',
  'bilnub',
  'gstcod',
  'crmPartyID',
  'iCx_ResID',
  'status',
  'guestPayload',
  'guestResponse',
 'resPayload',
  'resResponse' 
];
  ngOnInit() {
    
    this.route.queryParams.subscribe(params => {
      this.pmscode = +params['pmscode'];
      this.status = params['status'];
      this.selectedHotelName=params["hotelname"];
      this.fromDate = params['fromDate'];
      this.toDate = params['toDate'];
 this.stateData = history.state;
      this.loadFilteredData();
    });
  }

  loadFilteredData(){
    const payload = {
      PMSCODE: this.pmscode, // intentionally blank to fetch all
      FRMDATE: this.fromDate,
      TOODATE: this.toDate
    };

    this.apiCallIdsService.readITCCRMFOMAPINew(payload).subscribe(
      (data) => {
        const list = (data && data.list) ? data.list : [];

        if (this.status === 'Total') {
          this.filteredList = list.filter(item => item.pmscode === this.pmscode);
        }
         else {
          this.filteredList = list.filter(
            item =>
              item.pmscode === this.pmscode &&
              (item.status ? item.status.trim().toLowerCase() : '') === this.status.trim().toLowerCase()
          );
        }

        this.isLoading = false;
        console.log('Filtered List:', this.filteredList);
        this.filterProperty=this.filteredList;
      },
      (err) => {
        console.error('API Error:', err);
        this.filteredList = [];
        this.isLoading = false;
      }
    );
  }

  /*  goBack() {
    this.router.navigate(['/ITCFOM/fom-from-crmdb-ind']);
  }  */
 goBack() {

  window.history.back(); // or: this.location.back() if using Angular's Location service
}  

  showXml(pmscode:any, regnub:any,guestcode:any, xmltype: any) {
    console.log('xmltype =',xmltype)
    this.XMLstatus = this.LoadXML(pmscode, regnub,guestcode,xmltype);
     
  }
  LoadXML(pmscode: any, regnub: any, guestcode: any, xmltype: any) {
  const payload = {
    PMSCODE: pmscode,
    RESNUB: regnub,     // 👈 using RESNUB here as per your last code
    GUESTNUB: guestcode,
    TYPE: xmltype
  };
  console.log("jsonPayload", payload);

  this.isProgressing = true;
  this.apiCallIdsService.readITCCRMFOMAPINewJson(payload)
    .subscribe(
      data => {
        console.log('API Response =', data);

        if (!data || data.length < 1 || !data[0].jsonData) {
          this.toastr.error('No data Found');
          this.isProgressing = false;
          return;
        }

        let formatted = '';
        try {
          const raw = data[0].jsonData;

          if (typeof raw === 'string') {
            const trimmed = raw.trim();
            if (
              (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
              (trimmed.startsWith('[') && trimmed.endsWith(']'))
            ) {
              // ✅ Format JSON string
              const parsed = JSON.parse(trimmed);
              formatted = JSON.stringify(parsed, null, 2);
            } else {
              // ✅ Plain text (not JSON)
              formatted = trimmed;
            }
          } else if (typeof raw === 'object') {
            // ✅ Already an object
            formatted = JSON.stringify(raw, null, 2);
          } else {
            formatted = String(raw);
          }
        } catch (err) {
  console.error('Failed to format JSON:', err);
  this.toastr.error('Invalid JSON data');
  formatted = String(data[0].jsonData ? data[0].jsonData : '');
}


        // Set header name
        if (xmltype === "GuestRequest") this.XMLName = "Guest Request";
        else if (xmltype === "GuestResponse") this.XMLName = "Guest Response";
        else if (xmltype === "ResRequest") this.XMLName = "Res. Request";
        else if (xmltype === "ResResponse") this.XMLName = "Res. Response";

        this.defaultData = formatted;
        this.display = true;
        this.isProgressing = false;
      },
      error => {
        this.toastr.error("Failed to load requests !");
        this.isProgressing = false;
      }
    );
}
 closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
beautify(data: any): string {
  try {
    // If it's XML string
    if (typeof data === 'string' && data.trim().startsWith('<')) {
      return this.vkbeautify.xml(data); // if using vkbeautify
    }

    // If it's JSON object or string
    const obj = typeof data === 'string' ? JSON.parse(data) : data;
    return JSON.stringify(obj, null, 2);
  } catch {
    return data;
  }
}

  
   Search(searchTerm: string) {
  const term = (searchTerm || '').toLowerCase();

  if (!term) {
    this.filteredList = [...this.filterProperty]; // reset
    return;
  }

  this.filteredList = this.filterProperty.filter(item =>
    (item.regnub && item.regnub.toString().toLowerCase().includes(term)) ||
    (item.gstcod && item.gstcod.toString().toLowerCase().includes(term)) ||
    (item.bilnub && item.bilnub.toString().toLowerCase().includes(term)) ||
    (item.crmPartyID && item.crmPartyID.toString().toLowerCase().includes(term))
  );
}
pageSize = 50; // default value

pageEvent(event: PageEvent) {
  // Handle pagination event here
  console.log('Page changed:', event);
  // Add your logic to slice data or fetch new data based on page
}




}
